import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { longTestimonials, shortTestimonials } from '../data/testimonials';
import { stats } from '../data/copy';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-170" data-mp="3grj75qve3xsi">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-171" data-mp="3bqbxfm9osoj7" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-172" data-mp="3lqmbf93jpzzf">
        <div className="mx-auto max-w-3xl" data-id="element-173" data-mp="3cd6x05hhvd3">
          <h2 className="text-center font-display text-xl font-bold tracking-[.12em] text-brand-light sm:text-2xl" data-id="element-174" data-mp="3b1yuo50a1g6">
            📊 MADRES YA ORDENADAS
          </h2>
          <div className="mt-10 grid grid-cols-2 gap-x-5 gap-y-10" data-id="element-175" data-mp="db2n8ohqf7r8">
            {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-176" data-mp="8c9bp1m09qtp">
                <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-177" data-mp="1gd4l2076uiy7">{value}</p>
                <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-178" data-mp="1lbxzpvy7ofzy">
                  {label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-179" data-mp="1ud5nvl70k0gb">
        <div className="mx-auto max-w-6xl" data-id="element-180" data-mp="1uab13n0j23jq">
          <h2 className="mb-10 text-center font-display text-2xl font-bold sm:text-3xl" data-id="element-181" data-mp="1zcifskcqrxpr">
            💬 LO QUE DICEN LAS MADRES
          </h2>
          <div className="grid gap-5 md:grid-cols-3" data-id="element-182" data-mp="248qtdtbajiut">
            {shortTestimonials.map((item, index) => <motion.article key={item.name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-183" data-mp="293we4osyirhb" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-184" data-mp="ixgoh6pzfmqp">
                  <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-185" data-mp="iz1hut0k8zmz">
                    {item.initials}
                  </div>
                  <div data-id="element-186" data-mp="rwlm8atpzc1t">
                    <h3 className="font-bold" data-id="element-187" data-mp="rw25gxft2tpd">{item.name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-188" data-mp="16lq39oos3a8c">{item.place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-189" data-mp="11nold7339gyg">
                  <Stars data-id="element-190" data-mp="1fnh9cun8dj2q" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-191" data-mp="1fn7gmzaswxtc">“{item.quote}”</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-192" data-mp="3cg0z7mu9jrwi">
      <div className="mx-auto max-w-5xl" data-id="element-193" data-mp="3cidnehqm6yi0">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-194" data-mp="1rxp0zt0acpxo">
          💬 LO QUE DICEN LAS MADRES
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-195" data-mp="1wyw9jua95t5e">
          {longTestimonials.map(item => <article key={item.name} className="border-l-2 border-brand-green pl-4" data-id="element-196" data-mp="1j3u6rg0pcjwt">
              <Stars data-id="element-197" data-mp="1n5fhovtoeo4d" />
              <p className="mt-2 font-bold" data-id="element-198" data-mp="197h2jo7j6nnt">
                {item.name} <span className="font-normal text-slate-400" data-id="element-199" data-mp="195w77wde70ow">· {item.place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-200" data-mp="1e853p2ph4kvr">{item.quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}